import type { FaireReviewEntity } from "../../entity_types/review";

export const review_r7: FaireReviewEntity = {
  token: "review_r7",
  type: "review",
  brandName: "P.F. Candle Co.",
  reviewerName: "Ty",
  reviewerLocation: "Los Angeles, CA, United States",
  stars: 5,
  reviewText:
    "This line sells! The product is great — we love it, and our whole staff loves it and buys it for themselves too.",
  reviewDate: "Jan 16, 2025",
  reviewType: "brand",
  brandResponse:
    "Hi Ty! We absolutely love hearing this — especially that the whole team is obsessed. Your energy is everything. We can't wait to keep creating things you'll love.",
  reviewerPhotoUrls: [
    "https://cdn.prerelease.faire.dev/fastly/4aba30fa60e653c4f5417885f3b1b47c6ceb899b7bfdd856851b62999d9aa0eb.webp",
    "https://cdn.prerelease.faire.dev/fastly/414fbaf578dac0ac50e465687c9fa667a5038a53a7c73fc73195063594976768.jpeg",
  ],
  purchasedProductImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/a15d1fc087908754991b018a69774258782ff3fad6f50ef4078fe96c26a1caf6.webp",
    "https://cdn.prerelease.faire.dev/fastly/59a4005712dbc289690cccb048ed1838bfbb32630127b5ae4ce805f9204e0b93.webp",
    "https://cdn.prerelease.faire.dev/fastly/56884e66685193058ffed10b4132877eba11d2a0013a35e2fa68ec6fad9c8ed6.webp",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
